module.exports = __webpack_public_path__ + "Flaticon.84c42c02e0ab062e7c0d.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/fonts/Flaticon.ttf
// module id = ../../../../../src/fonts/Flaticon.ttf
// module chunks = styles